<template>
    <div>
        <h3 class="mb-3" :class="this.totalData.botMsg==0 && this.totalData.userMsg==0? 'text-center': ''">Total number of messages per bot/user</h3>

<!--        <div class="no-data-placeholder text-center" v-if="!this.series.length">-->
<!--            <img class="w-h-35 d-block mx-auto my-3" src="../../assets/img/box.svg">-->
<!--            <span class="italic d-block">-->
<!--                No available results for this time period-->
<!--            </span>-->
<!--        </div>-->
        <div class="no-data-placeholder text-center" v-if="this.totalData.botMsg==0 && this.totalData.userMsg==0">
            <v-progress-circular
                    :rotate="-90"
                    :size="220"
                    :value="100 "
                    :width="30"
                    color="grey"
            >
                <span>Total Messages</span>
                <span>0</span>
            </v-progress-circular>
        </div>
        <apex-chart type="donut" width='90%' :options="chartOptions" :series="series" ></apex-chart>
    </div>
</template>

<script>
    import apexChart from 'vue-apexcharts'
    export default {
        name: "total-messages",
        components: {
            apexChart
        },
        props: {
            totalData: {
                type: Object,
                default: ()=> {
                    return {}
                }
            }
        },
        data() {
            return {
                series: [],
                chartOptions: {
                    plotOptions: {
                        pie: {
                            donut: {


                                labels: {
                                    show: true,
                                    value: {
                                        offsetY: -1,
                                        show: true
                                    },
                                    total: {
                                        show: true,
                                        label: 'Total Messages',
                                        color: '#000'
                                    }
                                },
                            }
                        }
                    },
                    labels: [],
                    chart: {
                        type: 'donut'
                    }
                }
            }
        },
        mounted() {
            if (this.totalData.botMsg==0 && this.totalData.userMsg==0){
                this.series = [];
                this.chartOptions= {
                    labels: []
                };

            }else{
                this.series = [this.totalData.botMsg, this.totalData.userMsg]
                this.chartOptions= {
                    labels: ['Bot','User']
                }
            }

        },
        watch: {
            totalData() {
                if (this.totalData.botMsg==0 && this.totalData.userMsg==0){
                    this.series = [];
                    this.chartOptions= {
                        labels: []
                    };

                }else{
                    this.series = [this.totalData.botMsg, this.totalData.userMsg]
                    this.chartOptions= {
                        labels: ['Bot','User']
                    }
                }
            }
        }
    }
</script>

<style scoped>
    .no-data-placeholder{
        margin-top: 30px;
    }
</style>